import { Table } from 'antd';
import type { ColumnsType } from 'antd/es/table';
import type { SimulationUpload } from '~/store/simulation/types';

export interface UploadShipmentTableProps {
  data: SimulationUpload[];
  samplingPercentage: number;
}

export type OriginCountRecord = {
  origin: string;
  count: number;
  key: string;
};

export const UploadShipmentTable = ({ data, samplingPercentage }: UploadShipmentTableProps) => {
  if (!data) {
    return null;
  }

  const originCountMap = data?.reduce<Record<string, number>>((prev, val) => {
    const origins = Object.keys(val.details?.origins ?? {});
    for (const origin of origins) {
      if (!prev[origin]) {
        prev[origin] = 0;
      }
      prev[origin] += val.details?.origins?.[origin]?.shipmentCount ?? 0;
    }
    return prev;
  }, {});

  const originCountData = Object.keys(originCountMap).map((k) => {
    return {
      origin: k,
      count: originCountMap[k],
      key: k,
    };
  });

  const columns: ColumnsType<OriginCountRecord> = [
    {
      title: 'Origin Postal Code',
      key: 'origin',
      render: (row: OriginCountRecord) => {
        return row.origin;
      },
    },
    {
      title: 'Count',
      key: 'count',
      render: (row: OriginCountRecord) => {
        return row.count.toLocaleString();
      },
    },
    {
      title: 'Sampled Count',
      key: 'sampledCount',
      render: (row: OriginCountRecord) => {
        return Math.round((row.count * samplingPercentage) / 100).toLocaleString();
      },
    },
  ];

  return (
    <div>
      <Table
        style={{ marginTop: '16px' }}
        columns={columns}
        dataSource={originCountData}
        pagination={{ pageSize: 10 }}
      />
    </div>
  );
};
